import Ready from 'utils/ready';

Ready(() => {
  document.addEventListener('product:added', async ({ detail: { data: response } }) => {
    if (window.CookieInformation.getConsentGivenFor('cookie_cat_marketing') && window.ttq) {
      const data = await response.json();

      // Tiktok tracking
      window.ttq.track('AddToCart', {
        content_id: data.variant_id,
        content_type: 'product',
        quantity: data.quantity ?? 1,
        currency: window.theme.cart.currency,
        price: Number(data.line_price) / 100,
        value: Number(window.theme.cart.total_price) / 100,
      });
    }
  });
});
